// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.donation-form {
    width: 100%;
    max-width: 450px;
    margin: 0px auto;
    padding: 20px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
    background-color: #fff;
 
  }

  .policy-agreement {
    font-size: 0.9em; /* Smaller font size */
    color: grey; /* Grey text color */
    margin-top: 20px; /* Adds some space above the section */
    text-align: center;
    margin-bottom: 3vh;
    
  }
  
  
  .error-message {
    color: #3f3f3f !important;
    background: white;
    border: 1px solid #3f3f3f;
    padding: 5px;
    margin-top: 0px;
    margin-bottom: 5px;
    border-radius: 5px;
    box-sizing: border-box;
    text-align: center;
    font-size: 13px;
  }
  
  h1 {
    text-align: center;
    margin-bottom: 15px;
    color:#183340;

  }
  
  .frequency {
    display: grid;
    grid-template-columns: repeat(1, 1fr) !important;
    gap: 5px !important;
    margin-bottom: 20px;
  }
  
  .frequency-btn {
    flex: 1 1;
    padding: 10px;
    margin-right: 10px;
    border: 1px solid #ccc;
    background-color: #f8f8f8;
    cursor: pointer;
    text-align: center;
    border-radius: 5px;
    color: #183340;
  }

  .btn {
    flex: 1 1;
    padding: 10px;
    margin-right: 10px;
    border: 1px solid #ccc;
    background-color: #f8f8f8;
    cursor: pointer;
    text-align: center;
    border-radius: 5px;
    color: #183340;
  }
  
  .frequency-btn.selected, .frequency-btn:hover {
    background-color: #183340;
    color: white;
  }
  
  .frequency-btn:last-child {
    margin-right: 0;
  }
  
  .amounts {
    display: grid;
      grid-template-columns: repeat(1, 1fr) !important;
      gap: 5px !important;
      margin-bottom: 20px;
  }
  
  .amount, input[type="number"] {
    padding: 10px;
    border: 1px solid #ccc;
    background-color: #f8f8f8;
    cursor: pointer;
    text-align: center;
    border-radius: 5px;
    color: #183340;
  }
  
  .amount:hover {
    background-color: #183340;
    color: white;
  }
  
  .selected {
    background-color: #183340;
    color: white;
  }
  
  .options input[type="text"], .options input[type="email"] {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    margin-bottom: 10px;
    box-sizing: border-box;
    border-radius: 5px;
  }
  
  input[type="checkbox"] {
    margin-right: 5px;
    color-scheme:  #183340;
  }
  
  .input-prefix {
    position: relative;
  }
  
  .input-prefix::before {
    content: 'R';
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    color: #183340;
  }
  
  input[type="number"].prefix {
    padding-left: 20px;
  }
  
  label[for="dedicate"] {
    font-size: 15px;
  }

  .dedicate {
    color: #183340;
    text-decoration: underline;
    cursor: pointer;
    font-size: 15px !important; /* Apply the same font size to the link */
    margin-left: 0.2vw;
  }

 
  .next-btn {
    width: 100%;
    padding: 10px;
    background-color: #183340;
    color: white;
    border: none;
    cursor: pointer;
    margin-top: 10px;
    border-radius: 2px;
  }
  
  .next-btn.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
  
  .paystack-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    width: 100%;
    height: 100px;
  }
  
  .paystack-logo {
    margin-top: 10px;
    width: auto;
  }
  
  .text-style {
    font-family: Arial, sans-serif;
    font-size: 13px;
    color: #4a4a4a;
    padding: 10px;
  }
  
  
  .paystack-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    width: 100%;
    height: 100px;
  }
  
  .paystack-logo {
    margin-top: 10px;
    width: auto;
  }
  
  .text-style {
    font-family: Arial, sans-serif;
    font-size: 13px;
    color: #4a4a4a;
    padding: 10px;
  }

  .logo-image {
    display: block;
    width: 50%; /* Makes the image a third of its parent's width */
    margin: 0 auto;  /* Centers the image horizontally */
  }

  paystack-container {
    display: flex;
    justify-content: center; /* Center content horizontally */
    align-items: center; /* Center content vertically */
    margin-top: 20px;
    width: 100%; /* Adjust width to 100% of its parent if not restricted by parent */
    height: 100px; /* Adjust height based on your layout needs */
  }

  .paystack-logo {
    margin-top:10px;
    width: 100%; /* Adjust width to be auto to maintain image aspect ratio */
  }

  .paystack-text {
    vertical-align: middle;
  }

    /* For tablets */
  @media (min-width: 768px) and (max-width: 1366px) {
    .donation-form {
      width: 90%;  /* Adjust width to be more responsive on tablets */
      max-width: none;  /* Remove max-width restriction */
      margin: 10px auto;  /* Reduced margin for better use of space */
      padding: 25px;  /* Sufficient padding to keep form elements visually balanced */
    }
    label, input, button {
      font-size: 30px !important; /* Even larger font size for very large screens */
    }
    

    h1 {
      font-size: 50px; /* Even larger font size for very large screens */
    }

    h4 {
      font-size: 30px; /* Even larger font size for very large screens */
      text-align: center;
    }
  
    input, button {
      padding: 28px !important; /* More padding for better interaction */
      margin-top: 5px !important;
      margin-bottom: 5px;
      font-size: 30px !important;
    }
  
    label {
      font-size: 20px !important;
    }
  
    label[for="dedicate"] {
      font-size: 32px !important;
      margin-top: 10vh !important;
    }

    .dedicate {
      font-size: 32px !important; /* Apply the same font size to the link */
    }
  
    input[type="checkbox"] {
      height: 3vh;
      width: 3vw;
    
    }
    .input-prefix::before {
      font-size: 32px !important;
      margin-left: 15px !important;
    }
  
    .error-message {
      font-size: 28px !important; /* Default size */
      margin: 10px;
    }

    .paystack-container {
      padding-top: 18vh;
      margin-bottom: 18vh;
      max-width: 100%; /* Ensure it never exceeds the parent's width */
      max-height: 18vh !important;
      box-sizing: border-box; /* Include padding and border in the element's total width and height */
    }

    .next-btn {
      margin-top: 5vh !important;

    }
  }
  
  /* Additional Media Query for very small screens, such as smartphones */
  @media (min-width: 300px) and (max-width: 430px) {
    .donation-form {
      margin: 5px !important; /* Consistent smaller margin for very small screens */
      padding: 5px; /* Reduced padding to save space */
      justify-content: center; /* Centers the content */
      width: calc(100% - 10px) !important; /* Adjusts the width to account for margin */
      box-sizing: border-box; /* Includes padding and border in the element's total width and height */
    }
  
    label, input, button {
      font-size: 16px; /* Even larger font size for very large screens */
      padding: 5px;
    }
  
    .amounts {
      display: grid;
      grid-template-columns: repeat(1, 1fr) !important;
      gap: 5px !important;
      margin-bottom: 20px;
    
    }
  
    label[for="dedicate"] {
      font-size: 16px !important;
    }

    .dedicate {
      font-size: 16px !important; /* Apply the same font size to the link */
    }

    .paystack-container {
      margin-bottom: 5vh;
      margin-top: 5vh;
    }
  
    
  }@media (max-width: 1366px) {
    .donation-form {
      width: 100%;   /* Full width */
      max-width: 1000px; /* Removes the max-width restriction */
      margin: 10px;  /* Adjust margin for smaller screens */
      padding: 10px; /* Adjust padding for smaller screens */
    }
  }

  /* Mobile screens landscape */
  @media (min-width: 431px) and (max-width: 767px) {
    .donation-form {
      margin: 5px !important; /* Consistent smaller margin for very small screens */
      padding: 5px; /* Reduced padding to save space */
      justify-content: center; /* Centers the content */
      width: calc(100% - 10px) !important; /* Adjusts the width to account for margin */
      box-sizing: border-box; /* Includes padding and border in the element's total width and height */
    }
  
    label, input, button {
      font-size: 16px; /* Even larger font size for very large screens */
      padding: 5px;
    }
  
    .amounts {
      display: grid;
      grid-template-columns: repeat(1, 1fr) !important;
      gap: 5px !important;
      margin-bottom: 20px;
    
    }
  
    label[for="dedicate"] {
      font-size: 16px;
    }

    .paystack-container {
      margin-bottom: 15vh;
      margin-top: 15vh;
    }
  
  }`, "",{"version":3,"sources":["webpack://./src/PaymentForm.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,oCAAoC;IACpC,sBAAsB;;EAExB;;EAEA;IACE,gBAAgB,EAAE,sBAAsB;IACxC,WAAW,EAAE,oBAAoB;IACjC,gBAAgB,EAAE,sCAAsC;IACxD,kBAAkB;IAClB,kBAAkB;;EAEpB;;;EAGA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;;EAEf;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;MACX,gDAAgD;MAChD,mBAAmB;MACnB,mBAAmB;EACvB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,oBAAoB;IACpB,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,0BAA0B,EAAE,yCAAyC;IACrE,kBAAkB;EACpB;;;EAGA;IACE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,eAAe;IACf,cAAc;IACd,aAAa;EACf;;;EAGA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,eAAe;IACf,cAAc;IACd,aAAa;EACf;;EAEA;IACE,cAAc;IACd,UAAU,EAAE,kDAAkD;IAC9D,cAAc,GAAG,mCAAmC;EACtD;;EAEA;IACE,aAAa;IACb,uBAAuB,EAAE,gCAAgC;IACzD,mBAAmB,EAAE,8BAA8B;IACnD,gBAAgB;IAChB,WAAW,EAAE,mEAAmE;IAChF,aAAa,EAAE,6CAA6C;EAC9D;;EAEA;IACE,eAAe;IACf,WAAW,EAAE,2DAA2D;EAC1E;;EAEA;IACE,sBAAsB;EACxB;;IAEE,gBAAgB;EAClB;IACE;MACE,UAAU,GAAG,kDAAkD;MAC/D,eAAe,GAAG,iCAAiC;MACnD,iBAAiB,GAAG,2CAA2C;MAC/D,aAAa,GAAG,+DAA+D;IACjF;IACA;MACE,0BAA0B,EAAE,iDAAiD;IAC/E;;;IAGA;MACE,eAAe,EAAE,iDAAiD;IACpE;;IAEA;MACE,eAAe,EAAE,iDAAiD;MAClE,kBAAkB;IACpB;;IAEA;MACE,wBAAwB,EAAE,wCAAwC;MAClE,0BAA0B;MAC1B,kBAAkB;MAClB,0BAA0B;IAC5B;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,0BAA0B;MAC1B,2BAA2B;IAC7B;;IAEA;MACE,0BAA0B,EAAE,yCAAyC;IACvE;;IAEA;MACE,WAAW;MACX,UAAU;;IAEZ;IACA;MACE,0BAA0B;MAC1B,4BAA4B;IAC9B;;IAEA;MACE,0BAA0B,EAAE,iBAAiB;MAC7C,YAAY;IACd;;IAEA;MACE,iBAAiB;MACjB,mBAAmB;MACnB,eAAe,EAAE,+CAA+C;MAChE,2BAA2B;MAC3B,sBAAsB,EAAE,uEAAuE;IACjG;;IAEA;MACE,0BAA0B;;IAE5B;EACF;;EAEA,uEAAuE;EACvE;IACE;MACE,sBAAsB,EAAE,qDAAqD;MAC7E,YAAY,EAAE,kCAAkC;MAChD,uBAAuB,EAAE,wBAAwB;MACjD,mCAAmC,EAAE,4CAA4C;MACjF,sBAAsB,EAAE,wEAAwE;IAClG;;IAEA;MACE,eAAe,EAAE,iDAAiD;MAClE,YAAY;IACd;;IAEA;MACE,aAAa;MACb,gDAAgD;MAChD,mBAAmB;MACnB,mBAAmB;;IAErB;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,0BAA0B,EAAE,yCAAyC;IACvE;;IAEA;MACE,kBAAkB;MAClB,eAAe;IACjB;;;EAGF,CAAC;IACC;MACE,WAAW,IAAI,eAAe;MAC9B,iBAAiB,EAAE,sCAAsC;MACzD,YAAY,GAAG,sCAAsC;MACrD,aAAa,EAAE,uCAAuC;IACxD;EACF;;EAEA,6BAA6B;EAC7B;IACE;MACE,sBAAsB,EAAE,qDAAqD;MAC7E,YAAY,EAAE,kCAAkC;MAChD,uBAAuB,EAAE,wBAAwB;MACjD,mCAAmC,EAAE,4CAA4C;MACjF,sBAAsB,EAAE,wEAAwE;IAClG;;IAEA;MACE,eAAe,EAAE,iDAAiD;MAClE,YAAY;IACd;;IAEA;MACE,aAAa;MACb,gDAAgD;MAChD,mBAAmB;MACnB,mBAAmB;;IAErB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,mBAAmB;MACnB,gBAAgB;IAClB;;EAEF","sourcesContent":[".donation-form {\n    width: 100%;\n    max-width: 450px;\n    margin: 0px auto;\n    padding: 20px;\n    box-sizing: border-box;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    box-shadow: 0 0 10px rgba(0,0,0,0.1);\n    background-color: #fff;\n \n  }\n\n  .policy-agreement {\n    font-size: 0.9em; /* Smaller font size */\n    color: grey; /* Grey text color */\n    margin-top: 20px; /* Adds some space above the section */\n    text-align: center;\n    margin-bottom: 3vh;\n    \n  }\n  \n  \n  .error-message {\n    color: #3f3f3f !important;\n    background: white;\n    border: 1px solid #3f3f3f;\n    padding: 5px;\n    margin-top: 0px;\n    margin-bottom: 5px;\n    border-radius: 5px;\n    box-sizing: border-box;\n    text-align: center;\n    font-size: 13px;\n  }\n  \n  h1 {\n    text-align: center;\n    margin-bottom: 15px;\n    color:#183340;\n\n  }\n  \n  .frequency {\n    display: grid;\n    grid-template-columns: repeat(1, 1fr) !important;\n    gap: 5px !important;\n    margin-bottom: 20px;\n  }\n  \n  .frequency-btn {\n    flex: 1;\n    padding: 10px;\n    margin-right: 10px;\n    border: 1px solid #ccc;\n    background-color: #f8f8f8;\n    cursor: pointer;\n    text-align: center;\n    border-radius: 5px;\n    color: #183340;\n  }\n\n  .btn {\n    flex: 1;\n    padding: 10px;\n    margin-right: 10px;\n    border: 1px solid #ccc;\n    background-color: #f8f8f8;\n    cursor: pointer;\n    text-align: center;\n    border-radius: 5px;\n    color: #183340;\n  }\n  \n  .frequency-btn.selected, .frequency-btn:hover {\n    background-color: #183340;\n    color: white;\n  }\n  \n  .frequency-btn:last-child {\n    margin-right: 0;\n  }\n  \n  .amounts {\n    display: grid;\n      grid-template-columns: repeat(1, 1fr) !important;\n      gap: 5px !important;\n      margin-bottom: 20px;\n  }\n  \n  .amount, input[type=\"number\"] {\n    padding: 10px;\n    border: 1px solid #ccc;\n    background-color: #f8f8f8;\n    cursor: pointer;\n    text-align: center;\n    border-radius: 5px;\n    color: #183340;\n  }\n  \n  .amount:hover {\n    background-color: #183340;\n    color: white;\n  }\n  \n  .selected {\n    background-color: #183340;\n    color: white;\n  }\n  \n  .options input[type=\"text\"], .options input[type=\"email\"] {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #ccc;\n    margin-bottom: 10px;\n    box-sizing: border-box;\n    border-radius: 5px;\n  }\n  \n  input[type=\"checkbox\"] {\n    margin-right: 5px;\n    color-scheme:  #183340;\n  }\n  \n  .input-prefix {\n    position: relative;\n  }\n  \n  .input-prefix::before {\n    content: 'R';\n    position: absolute;\n    left: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    pointer-events: none;\n    color: #183340;\n  }\n  \n  input[type=\"number\"].prefix {\n    padding-left: 20px;\n  }\n  \n  label[for=\"dedicate\"] {\n    font-size: 15px;\n  }\n\n  .dedicate {\n    color: #183340;\n    text-decoration: underline;\n    cursor: pointer;\n    font-size: 15px !important; /* Apply the same font size to the link */\n    margin-left: 0.2vw;\n  }\n\n \n  .next-btn {\n    width: 100%;\n    padding: 10px;\n    background-color: #183340;\n    color: white;\n    border: none;\n    cursor: pointer;\n    margin-top: 10px;\n    border-radius: 2px;\n  }\n  \n  .next-btn.disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    pointer-events: none;\n  }\n  \n  .paystack-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 20px;\n    width: 100%;\n    height: 100px;\n  }\n  \n  .paystack-logo {\n    margin-top: 10px;\n    width: auto;\n  }\n  \n  .text-style {\n    font-family: Arial, sans-serif;\n    font-size: 13px;\n    color: #4a4a4a;\n    padding: 10px;\n  }\n  \n  \n  .paystack-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 20px;\n    width: 100%;\n    height: 100px;\n  }\n  \n  .paystack-logo {\n    margin-top: 10px;\n    width: auto;\n  }\n  \n  .text-style {\n    font-family: Arial, sans-serif;\n    font-size: 13px;\n    color: #4a4a4a;\n    padding: 10px;\n  }\n\n  .logo-image {\n    display: block;\n    width: 50%; /* Makes the image a third of its parent's width */\n    margin: 0 auto;  /* Centers the image horizontally */\n  }\n\n  paystack-container {\n    display: flex;\n    justify-content: center; /* Center content horizontally */\n    align-items: center; /* Center content vertically */\n    margin-top: 20px;\n    width: 100%; /* Adjust width to 100% of its parent if not restricted by parent */\n    height: 100px; /* Adjust height based on your layout needs */\n  }\n\n  .paystack-logo {\n    margin-top:10px;\n    width: 100%; /* Adjust width to be auto to maintain image aspect ratio */\n  }\n\n  .paystack-text {\n    vertical-align: middle;\n  }\n\n    /* For tablets */\n  @media (min-width: 768px) and (max-width: 1366px) {\n    .donation-form {\n      width: 90%;  /* Adjust width to be more responsive on tablets */\n      max-width: none;  /* Remove max-width restriction */\n      margin: 10px auto;  /* Reduced margin for better use of space */\n      padding: 25px;  /* Sufficient padding to keep form elements visually balanced */\n    }\n    label, input, button {\n      font-size: 30px !important; /* Even larger font size for very large screens */\n    }\n    \n\n    h1 {\n      font-size: 50px; /* Even larger font size for very large screens */\n    }\n\n    h4 {\n      font-size: 30px; /* Even larger font size for very large screens */\n      text-align: center;\n    }\n  \n    input, button {\n      padding: 28px !important; /* More padding for better interaction */\n      margin-top: 5px !important;\n      margin-bottom: 5px;\n      font-size: 30px !important;\n    }\n  \n    label {\n      font-size: 20px !important;\n    }\n  \n    label[for=\"dedicate\"] {\n      font-size: 32px !important;\n      margin-top: 10vh !important;\n    }\n\n    .dedicate {\n      font-size: 32px !important; /* Apply the same font size to the link */\n    }\n  \n    input[type=\"checkbox\"] {\n      height: 3vh;\n      width: 3vw;\n    \n    }\n    .input-prefix::before {\n      font-size: 32px !important;\n      margin-left: 15px !important;\n    }\n  \n    .error-message {\n      font-size: 28px !important; /* Default size */\n      margin: 10px;\n    }\n\n    .paystack-container {\n      padding-top: 18vh;\n      margin-bottom: 18vh;\n      max-width: 100%; /* Ensure it never exceeds the parent's width */\n      max-height: 18vh !important;\n      box-sizing: border-box; /* Include padding and border in the element's total width and height */\n    }\n\n    .next-btn {\n      margin-top: 5vh !important;\n\n    }\n  }\n  \n  /* Additional Media Query for very small screens, such as smartphones */\n  @media (min-width: 300px) and (max-width: 430px) {\n    .donation-form {\n      margin: 5px !important; /* Consistent smaller margin for very small screens */\n      padding: 5px; /* Reduced padding to save space */\n      justify-content: center; /* Centers the content */\n      width: calc(100% - 10px) !important; /* Adjusts the width to account for margin */\n      box-sizing: border-box; /* Includes padding and border in the element's total width and height */\n    }\n  \n    label, input, button {\n      font-size: 16px; /* Even larger font size for very large screens */\n      padding: 5px;\n    }\n  \n    .amounts {\n      display: grid;\n      grid-template-columns: repeat(1, 1fr) !important;\n      gap: 5px !important;\n      margin-bottom: 20px;\n    \n    }\n  \n    label[for=\"dedicate\"] {\n      font-size: 16px !important;\n    }\n\n    .dedicate {\n      font-size: 16px !important; /* Apply the same font size to the link */\n    }\n\n    .paystack-container {\n      margin-bottom: 5vh;\n      margin-top: 5vh;\n    }\n  \n    \n  }@media (max-width: 1366px) {\n    .donation-form {\n      width: 100%;   /* Full width */\n      max-width: 1000px; /* Removes the max-width restriction */\n      margin: 10px;  /* Adjust margin for smaller screens */\n      padding: 10px; /* Adjust padding for smaller screens */\n    }\n  }\n\n  /* Mobile screens landscape */\n  @media (min-width: 431px) and (max-width: 767px) {\n    .donation-form {\n      margin: 5px !important; /* Consistent smaller margin for very small screens */\n      padding: 5px; /* Reduced padding to save space */\n      justify-content: center; /* Centers the content */\n      width: calc(100% - 10px) !important; /* Adjusts the width to account for margin */\n      box-sizing: border-box; /* Includes padding and border in the element's total width and height */\n    }\n  \n    label, input, button {\n      font-size: 16px; /* Even larger font size for very large screens */\n      padding: 5px;\n    }\n  \n    .amounts {\n      display: grid;\n      grid-template-columns: repeat(1, 1fr) !important;\n      gap: 5px !important;\n      margin-bottom: 20px;\n    \n    }\n  \n    label[for=\"dedicate\"] {\n      font-size: 16px;\n    }\n\n    .paystack-container {\n      margin-bottom: 15vh;\n      margin-top: 15vh;\n    }\n  \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
